export default {
  getToken(state) {
    if (state.token == "" || state.token == null || state.token == undefined)
      return localStorage.getItem("token") || "";
    else return state.token;
  },

  getUser(state) {
    if (state.user == "" || state.user == null || state.user == undefined)
      return localStorage.getItem("user") || "";
    else return state.user;
  },

  isAuth(state) {
    var user = localStorage.getItem("user");
    var token = localStorage.getItem("token");
    if ((state.token && state.user) || (user != null && token != null))
      state.auth = true;
    else state.auth = false;
    return state.auth;
  },

  getCampings(state) {
    if (
      state.campings == "" ||
      state.campings == null ||
      state.campings == undefined
    )
      return JSON.parse(localStorage.getItem("campings")) || [];
    else return state.campings;
  },

  getCamping(state) {
    return state.camping;
  },

  getUsers(state) {
    if (state.users == "" || state.users == null || state.users == undefined)
      return JSON.parse(localStorage.getItem("users")) || [];
    else return state.users;
  },

  getScontoSoloSuUnita(state) {
    return state.parameters.scontoSoloSuUnita;
  },
};
